/* eslint-disable import/no-cycle */
import Api from '@/api';

const theState = {
    loading: false,
    removing: false,
    showDialog: false,
    selectedAtomIds: [],
};

const actions = {
    unlinkAccount({ commit, state, dispatch }, ssoId) {
        /* eslint-disable arrow-body-style */
        const promises = state.selectedAtomIds.map((atomId) => {
            return new Promise((resolve, reject) => {
                Api.customer.removeLinkedAccount(ssoId, atomId)
                    .then(() => {
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
            });
        });

        commit('setRemoving', true);
        return Promise.all(promises)
            .then(() => {
                commit('hideDialog');
                dispatch('customerLinkedAccounts/getLinkedAccounts', ssoId, { root: true });
                dispatch('customerLinkedAccounts/getLinkedAccountsSummary', ssoId, { root: true });
            })
            .finally(() => {
                commit('setRemoving', false);
            });
    },
};

const mutations = {
    resetState(state) {
        state.loading = false;
        state.removing = false;
        state.showDialog = false;
    },

    hideDialog(state) {
        state.showDialog = false;
        state.selectedAtomIds = [];
    },

    openDialog(state, atomIds) {
        state.showDialog = true;
        state.selectedAtomIds = atomIds;
    },

    setLoading(state, loading) {
        state.loading = loading;
    },

    setRemoving(state, removing) {
        state.removing = removing;
    },
};

export default {
    namespaced: true,
    state: theState,
    actions,
    mutations,
};
